import React from "react";
import { Pane } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import NavComponent from "../../components/NavComponent";
import { RecekPaneSet } from "../../components/RecekPaneSet";
import AdminEnvironmentVariables from "../../components/admin/AdminEnvironmentVariables";
import PublisherSynchronize from "../../components/admin/PublisherSynchronize";
import { LegalDepositsSynchronize } from "../../components/admin/LegalDepositsSynchronize";
import { AgencySynchronize } from "../../components/admin/AgencySynchronize";
import { IdzRecekIdMappingExport } from "../../components/admin/IdzRecekIdMappingExport";
var AdminPage = function () {
    var formatMessage = useIntl().formatMessage;
    return (React.createElement(RecekPaneSet, null,
        React.createElement(Pane, { id: "menuPane", defaultWidth: "25%", paneTitle: formatMessage({ id: "ui-br-publishers.pane.title.navigation" }) },
            React.createElement("div", { style: { display: "flex", flexDirection: "column" } },
                React.createElement(NavComponent, null))),
        React.createElement(Pane, { id: "contentPane", defaultWidth: "fill", paneTitle: React.createElement(FormattedMessage, { id: "ui-br-publishers.admin.title" }) },
            React.createElement(AdminEnvironmentVariables, null),
            React.createElement(PublisherSynchronize, null),
            React.createElement(LegalDepositsSynchronize, null),
            React.createElement(AgencySynchronize, null),
            React.createElement(IdzRecekIdMappingExport, null))));
};
export default AdminPage;
